import React from 'react';

export default function HorseMetadata({ horse }) {
  if (!horse) return null;

  const {
    horseInfo = {},
    saleInfo = {},
    status,
  } = horse;

  const {
    breed,
    age,
    location,
    description,
  } = horseInfo;

  const price = saleInfo.buyNowPrice || saleInfo.auctionStartingPrice || 0;

  const breedLabel = typeof breed === 'object' && breed?.name
    ? breed.name
    : typeof breed === 'string'
    ? `Breed ID: ${breed.slice(0, 6)}...`
    : 'Unknown';

  return (
    <div className="mt-5 p-3 font-montserrat shadow">
      <h2 className="text-xl font-bold mb-2">Details</h2>
      <p className="py-2"><strong>Breed:</strong> {breedLabel}</p>
      <p className="py-2"><strong>Age:</strong> {age}</p>
      <p className="py-2"><strong>Status:</strong> {status}</p>
      <p className="py-2"><strong>Price:</strong> {price ? `$${price.toLocaleString()}` : 'N/A'}</p>
      <p className="py-2"><strong>Location:</strong> {location?.formattedAddress || 'N/A'}</p>
      <p className="py-2"><strong>Description:</strong> {description || 'N/A'}</p>
    </div>
  );
}